import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime free replacement',
  body: 'Break it and we replace it. Forever.',
  gold: true
}, {
  icon: LayersIcon,
  title: '3 lenses in every box',
  body: 'Clear, Amber and Smoke included.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'On every multi-pack order.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: '1 X1 for $39.95',
    href: '/#offer'
  }, {
    label: 'Full-Shift Kit: 3 X1 for $74.95',
    href: '/#offer'
  }, {
    label: 'Max Value: 5 X1 for $119.85',
    href: '/#offer'
  }, {
    label: 'Business / crew pack for $599',
    href: '/#offer'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Lifetime guarantee terms',
  to: '/legal/guarantee'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-726" data-mp="2c90j8y1cvhr8">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-727" data-mp="2m1mmk5nskcnv">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-728" data-mp="2h42x09ln8dgm">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-729" data-mp="283eqs12hrhea">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-730" data-mp="1ycadd5sgs4lk" />
                <span data-id="element-731" data-mp="1pdgbazwd6m0m">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-732" data-mp="1pdyj8tse2ood">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-733" data-mp="3r1b1xodiuc8p">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-734" data-mp="4vnv0ms1e8ft">
        <div data-id="element-735" data-mp="8vet7bjw7qud">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-736" data-mp="8tvdpn629jtn">
            Grit<span className="text-grit-500" data-id="element-737" data-mp="3d9wkvn36cl4a">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-738" data-mp="3d8bort17ou4b">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-739" data-mp="3haq80e8slvw4">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-740" data-mp="2plmzundsc1e7">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-741" data-mp="25jsayfgpoxs4">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-742" data-mp="2k8565a7z6clk">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-743" data-mp="2ffls6c5dlfg8">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvue.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-744" data-mp="2oa09ek9gv01z">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-745" data-mp="2y5k2kywnbkn1" />
              support@gritvue.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-746" data-mp="13twuiaoqtnop">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-747" data-mp="3fitmj9j7dgs7">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-748" data-mp="35qxep6rbecas">
                Shipping &amp; returns warehouse
              </span>
              GritVue Fulfillment
              <br data-id="element-749" data-mp="2wqh99rr0gv3a" />
              4820 Wingate Industrial Blvd, Building C, Dock 4
              <br data-id="element-750" data-mp="30ruh27dnz8cu" />
              Fort Worth, TX 76106
            </address>
            <div className="mt-4" data-id="element-751" data-mp="30t5hpybtbzzq">
              <UspsBadge data-id="element-752" data-mp="2msbavk4ey736" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-753" data-mp="2rqmkbtqsqfkv">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-754" data-mp="2rt8t1wpfb14o">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-755" data-mp="q019uc6ovzdi">
              {column.links.map(link => <li key={link.label} data-id="element-756" data-mp="oivzvblskt1p">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-757" data-mp="ojxbpiamtjkh">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-758" data-mp="178u4tiuam614">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-759" data-mp="178kfzykzi4x0">
          <nav aria-label="Legal" data-id="element-760" data-mp="xjaj85f73y2k">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-761" data-mp="xi90rfvuo9at">
              {legal.map(item => <li key={item.label} data-id="element-762" data-mp="sj670rlblpi5">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-763" data-mp="si4s2c16oiv5">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-764" data-mp="1xk5mo05aeepc">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-765" data-mp="1xjmgthswvgro">Secure checkout</p>
            <div className="mt-2" data-id="element-766" data-mp="22gw4ot0njkde">
              <PaymentLogos data-id="element-767" data-mp="27h0mqnh7kn5q" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-768" data-mp="2cgd7n2oirk5o">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-769" data-mp="2cflmymwgn6u6">
          <p className="text-xs text-steel-500" data-id="element-770" data-mp="2gfm2kavapo2t">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-771" data-mp="2q7s163g1z3qz">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-772" data-mp="305z8dukji7fs">Light where you look</p>
        </div>
      </div>
    </footer>;
}